import { domain } from 'modules/data';
import { getPreferredAccountingSystemSignUp, getUseCasesSignUp } from 'shared/helpers';
import { PreferredAccountingSystem } from 'shared/helpers/qualificationQuestionsAnswers/preferredAccountingSystemSignUp';

import {
    mapTextByUseCases,
    videoLinksQBooks,
    videoLinksStandalone,
    videoLinksStandalonePreferredQbooks,
    videoLinksXero,
} from './GettingStarted.constants';
import { messages } from './GettingStarted.messages';

export const getTextByUseCase = () => {
    const casesFromStorage = getUseCasesSignUp();

    if (!casesFromStorage) {
        return messages.default;
    }

    return mapTextByUseCases[casesFromStorage] || messages.default;
};

export function getVideoLinks(integrationType?: domain.IntegrationType) {
    if (!integrationType || integrationType === domain.IntegrationType.None) {
        const preferedAccountingSystemSignUp = getPreferredAccountingSystemSignUp();

        if (preferedAccountingSystemSignUp === PreferredAccountingSystem.QBooks) {
            return videoLinksStandalonePreferredQbooks;
        }

        return videoLinksStandalone;
    }

    if (integrationType === domain.IntegrationType.QBooks) {
        return videoLinksQBooks;
    }

    return videoLinksXero;
}
